import { render, staticRenderFns } from "./CorportateProfile.vue?vue&type=template&id=546e60e5&"
import script from "./CorportateProfile.vue?vue&type=script&lang=js&"
export * from "./CorportateProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports